export default {
  token: "GTM-KVMV42B", // TODO: from AppSettings.txt
  isDebug: location.search.indexOf("gtm_debug") >= 0,
  useGAECommerce: true,
  modifiers: {
    QueryProducts(e) {
      //logic to modify the event
    },
  },
};
